  // CURSOR
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursor-ring');
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
  (function animCursor() {
    rx += (mx - rx) * 0.15;
    ry += (my - ry) * 0.15;
    cursor.style.left = mx + 'px';
    cursor.style.top = my + 'px';
    ring.style.left = rx + 'px';
    ring.style.top = ry + 'px';
    requestAnimationFrame(animCursor);
  })();
  document.querySelectorAll('a, button').forEach(el => {
    el.addEventListener('mouseenter', () => {
      cursor.style.width = '18px'; cursor.style.height = '18px';
      ring.style.width = '50px'; ring.style.height = '50px';
    });
    el.addEventListener('mouseleave', () => {
      cursor.style.width = '10px'; cursor.style.height = '10px';
      ring.style.width = '36px'; ring.style.height = '36px';
    });
  });

  // NAV SCROLL
  const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 80);
  });

  // PARALLAX HERO BOTTLE
  const bottle = document.getElementById('hero-bottle');
  window.addEventListener('scroll', () => {
    const s = window.scrollY;
    if (bottle) {
      bottle.style.transform = `translateY(calc(-50% + ${s * 0.15}px))`;
    }
  });

  // INTERSECTION OBSERVER — cinematic scroll reveals
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  // Product cards
  document.querySelectorAll('.product-card').forEach(el => observer.observe(el));

  // Featured
  const featVis = document.getElementById('feat-visual');
  const featCont = document.getElementById('feat-content');
  if (featVis) observer.observe(featVis);
  if (featCont) observer.observe(featCont);

  // Process steps
  document.querySelectorAll('.process-step').forEach(el => observer.observe(el));

  // Filler cards
  document.querySelectorAll('.filler-card').forEach(el => observer.observe(el));

  // Testimonial
  const tq = document.getElementById('testimonial-quote');
  const td = document.getElementById('test-div');
  const ta = document.getElementById('test-author');
  if (tq) observer.observe(tq);
  if (td) observer.observe(td);
  if (ta) observer.observe(ta);

  // Intro / CTA reveal
  document.querySelectorAll('.reveal-left, .reveal-right').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = el.classList.contains('reveal-left') ? 'translateX(-50px)' : 'translateX(50px)';
    el.style.transition = 'opacity 1s cubic-bezier(0.16,1,0.3,1), transform 1s cubic-bezier(0.16,1,0.3,1)';
    const revObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateX(0)';
        }
      });
    }, { threshold: 0.15 });
    revObs.observe(el);
  });

  // SMOOTH SCROLL
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });
